<bmc-icons-16></bmc-icons-16>
<bmc-icons-32></bmc-icons-32>

<form id="wsfLogin" action="api/auth/wsfederation/Login" method="post" style="display:none"></form>
<form id="wsfLogout" action="api/auth/wsfederation/Logout" method="post" style="display:none"></form>
<router-outlet></router-outlet>
